// Cognito認証トークン（idToken/accessToken/refreshToken）のlocalStorageアクセスを一元化するユーティリティ。
// 保存先自体はlocalStorageのまま変更しないが、直接アクセスをここに集約することで
// 将来の保存方式変更（httpOnly Cookie化等）や監査を容易にする。
const ID_TOKEN_KEY = "idToken";
const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";

export type AuthTokens = {
  idToken: string;
  accessToken: string;
  refreshToken: string;
};

/**
 * localStorageからidTokenを取得する
 * @returns idToken（未保存の場合はnull）
 */
export const getIdToken = (): string | null => {
  return localStorage.getItem(ID_TOKEN_KEY);
};

/**
 * localStorageからaccessTokenを取得する
 * @returns accessToken（未保存の場合はnull）
 */
export const getAccessToken = (): string | null => {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};

/**
 * localStorageからrefreshTokenを取得する
 * @returns refreshToken（未保存の場合はnull）
 */
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

/**
 * idToken/accessToken/refreshTokenをlocalStorageへ保存する
 * @param tokens 保存する認証トークン一式
 */
export const saveAuthToken = (tokens: AuthTokens): void => {
  localStorage.setItem(ID_TOKEN_KEY, tokens.idToken);
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
};

/**
 * localStorageから認証トークン（idToken/accessToken/refreshToken）をすべて削除する
 */
export const clearAuthToken = (): void => {
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};
